export const REFETCH_STACK_SETTINGS_QUERIES = ["GetStackSettings"];
export const REFETCH_STACK_AND_STACK_SETTINGS_QUERIES = ["GetStackSettings", "GetStack"];
